/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AssignmentError = 'NotFound' | 'AmbiguousMatch' | 'CannotComplete' | 'NotReopened' | 'AlreadyCompleted' | 'Unknown';

export const AssignmentError = {
    NotFound: 'NotFound' as AssignmentError,
    AmbiguousMatch: 'AmbiguousMatch' as AssignmentError,
    CannotComplete: 'CannotComplete' as AssignmentError,
    NotReopened: 'NotReopened' as AssignmentError,
    AlreadyCompleted: 'AlreadyCompleted' as AssignmentError,
    Unknown: 'Unknown' as AssignmentError
};

